const updates = [
  {
    date: '2026-07-31',
    title: '《长相思》更新至第32集',
    desc: '杨紫、张晚意主演古装神话剧，剧情进入高潮阶段，小夭身世之谜即将揭晓，全网热度飙升。',
    tag: '热播更新',
  },
  {
    date: '2026-07-30',
    title: '《莲花楼》全集高清上线',
    desc: '成毅、曾舜晞主演武侠探案剧，全集40集一次放出，悬疑推理与江湖侠义完美融合。',
    tag: '全集上线',
  },
  {
    date: '2026-07-29',
    title: '《长风渡》完结版全网首发',
    desc: '白敬亭、宋轶主演古装商战爱情剧，全集高清版本已入库，口碑爆棚引发追剧热潮。',
    tag: '完结上线',
  },
  {
    date: '2026-07-28',
    title: '《七时吉祥》新剧开播',
    desc: '杨超越、丁禹兮主演仙侠爱情剧，首播即登热搜，快看影视同步上线高清版本。',
    tag: '新剧上线',
  },
  {
    date: '2026-07-27',
    title: '《安乐传》大结局上线',
    desc: '迪丽热巴、龚俊主演古装传奇剧圆满收官，全集高清版本已整理入库，回顾经典剧情。',
    tag: '大结局',
  },
  {
    date: '2026-07-26',
    title: '《玉骨遥》4K修复版上线',
    desc: '肖战、任敏主演仙侠剧，4K高清修复版本全新上线，画质升级带来沉浸式观影体验。',
    tag: '画质升级',
  },
  {
    date: '2026-07-25',
    title: '《偷偷藏不住》每日连更中',
    desc: '赵露思、陈哲远主演青春暗恋剧，快看影视同步每日更新，甜度爆表引发全网追更。',
    tag: '每日连更',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          最新动态
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          每日同步更新，好剧不错过
        </p>
        <div className="mt-10 space-y-4">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-colors cursor-pointer"
            >
              <span className="text-xs text-foreground-400 font-mono whitespace-nowrap w-24">
                {item.date}
              </span>
              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-800 whitespace-nowrap w-fit">
                {item.tag}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}